export const PAYMENT_LINK_EVENTS = {
  API_PAYMENT_LINK_GET_INFORMATION_SUCCESS:
    'api_payment_link_get_information_success',
  API_PAYMENT_LINK_GET_INFORMATION_ERROR:
    'api_payment_link_get_information_error',
  API_PAYMENT_LINK_CREATE_PUBLIC_CHECKOUT_LINK_SUCCESS:
    'api_payment_link_create_public_checkout_link_success',
  API_PAYMENT_LINK_CREATE_PUBLIC_CHECKOUT_LINK_ERROR:
    'api_payment_link_create_public_checkout_link_error',
  VIEW_REQUEST_MONEY_PAYMENT_REQUEST: 'view_request_money_payment_request',
  VIEW_REQUEST_MONEY_INVALID_LINK: 'view_request_money_invalid_link',
  VIEW_REQUEST_MONEY_LINK_EXPIRED: 'view_request_money_link_expired',
  VIEW_REQUEST_MONEY_PAYMENT_OPTIONS: 'view_request_money_payment_options',
  SELECT_REQUEST_MONEY_PAYMENT_OPTION: 'select_request_money_payment_option',
  VIEW_REQUEST_MONEY_PAYMENT_CONFIRMATION:
    'view_request_money_payment_confirmation',
  SELECT_REQUEST_MONEY_PAYMENT_INFO_CONFIRM:
    'select_request_money_payment_info_confirm',
  SELECT_REQUEST_MONEY_PAYMENT_CONFIRMATION_TERMS_CONDITIONS:
    'select_request_money_payment_confirmation_terms_conditions',
  SELECT_SEND_ON_REQUEST_MONEY_PAYMENT: 'select_send_on_request_money_payment',
  SELECT_REQUEST_MONEY_JOIN_MODAK: 'select_request_money_join_modak',
  SELECT_GET_HELP_ON_REQUEST_MONEY_PAYMENT_ERROR:
    'select_get_help_on_request_money_payment_error',
  API_CHECKOUT_FEES: 'api_checkout_fees',
  SELECT_PAYMENT_LINK_CUSTOM_AMOUNT: 'select_payment_link_custom_amount',
} as const;

export const PAYMENT_LINK_OUTCOME_EVENTS = {
  API_REQUEST_MONEY_PAYMENT_ERROR: 'api_request_money_payment_error',
  API_REQUEST_MONEY_PAYMENT_OUTCOME_SUCCESS:
    'api_request_money_payment_outcome_success',
  VIEW_REQUEST_MONEY_PAYMENT_OUTCOME_SUCCESS:
    'view_request_money_payment_outcome_success',
} as const;

export const PAYMENT_LINK_V2_EVENTS = {
  view_request_money_success_screen: 'view_request_money_success_screen',
  view_request_money_error_screen: 'view_request_money_error_screen',
  api_limit_fees_success: 'api_limit_fees_success',
  api_limit_fees_error: 'api_limit_fees_error',
  api_request_money_create_session_success:
    'api_request_money_create_session_success',
  api_request_money_create_session_error:
    'api_request_money_create_session_error',
  // Replaces api_request_money_submit_payment_session_success (fundraising events spec)
  api_request_money_paid_success: 'api_request_money_paid_success',
  // Replaces api_request_money_submit_payment_session_error (fundraising events spec)
  api_request_money_paid_error: 'api_request_money_paid_error',
  view_request_money_personal_info: 'view_request_money_personal_info',
  select_request_money_personal_info_continue:
    'select_request_money_personal_info_continue',
  view_request_money_payment_info: 'view_request_money_payment_info',
  select_request_money_share_initiative:
    'select_request_money_share_initiative',
  checkout_web_component_on_ready: 'checkout_web_component_on_ready',
  checkout_web_component_on_submit: 'checkout_web_component_on_submit',
  checkout_web_component_on_click: 'checkout_web_component_on_click',
  checkout_web_component_on_tokenized: 'checkout_web_component_on_tokenized',
  checkout_web_component_on_authorized: 'checkout_web_component_on_authorized',
} as const;
